import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as RadioButtonChecked } from "../../images/RadioButtonChecked.svg";
import  { ReactComponent as RadioButtonUnchecked }  from "../../images/RadioButtonUnchecked.svg";
import { EmailSelectorInnerWrapper, EmailSelectorWrapper } from "./styled.js";

const EmailProviderOption = ({ provider, isSelected, onSelect }) => {
  return (
    <EmailSelectorWrapper
      onClick={() => onSelect(provider.TENANT_ID)}
      style={{
        borderColor: isSelected ? "#506DFF" : "#D6DDE8",
      }}
    >
      {isSelected ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
      <EmailSelectorInnerWrapper>
        <provider.ICON />
        {provider.NAME}
      </EmailSelectorInnerWrapper>
    </EmailSelectorWrapper>
  );
};

EmailProviderOption.propTypes = {
  provider: PropTypes.shape({
    NAME: PropTypes.string.isRequired,
    ICON: PropTypes.elementType.isRequired,
    TENANT_ID: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default EmailProviderOption;